import styled from "styled-components";



export const SkillsSectionContainer = styled.div`
  margin: 0 auto;
  width:100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: rgb(0, 0, 0, 0.02);
  padding: 3em 3em 3em;
  text-align: center;
  margin-bottom:2em;
  & h1 {
    font-size: 2.3em;
    padding:0.4em;

  }
  & div {
    max-width: 700px;
    width: 100%;
    line-height: 2;
    font-size: 15px;
  }
  
`;

export const SkillsSectionContainerWrapper = styled.div`
margin-bottom: 2.3em;

`



